import { createReducer, on } from '@ngrx/store';
import { addOREditFilter, deleteFilter, deleteAllFilters } from '../actions/app.actions';
export const initialState = [];
const ɵ0 = (state, { filter_name, value }) => {
    if (state.filter(filter => filter.filter_name == filter_name).length == 0) {
        return [
            ...state,
            {
                filter_name: filter_name,
                value: value
            }
        ];
    }
    else {
        return state.map(filter => {
            if (filter.filter_name != filter_name) {
                return filter;
            }
            else {
                return {
                    filter_name: filter_name,
                    value: value
                };
            }
        });
    }
}, ɵ1 = (state, { filter_name }) => state.filter(item => item.filter_name != filter_name), ɵ2 = state => [];
const _filterReducer = createReducer(initialState, on(addOREditFilter, ɵ0), on(deleteFilter, ɵ1), on(deleteAllFilters, ɵ2));
export function filterReducer(state, action) {
    return _filterReducer(state, action);
}
export { ɵ0, ɵ1, ɵ2 };
